// extracted by mini-css-extract-plugin
export var autoExpand = "_1x-8";
export var container = "_1x-7";
export var containerWidth = "_1x-5";
export var disabled = "_1x-2";
export var error = "_1x-3";
export var fullWidth = "_1x-6";
export var inputWrapper = "_1x-0";
export var small = "_1x-1";
export var textarea = "_1x-4";